import { SearchDashboard, NetsuiteTransactionRes } from '@/models/netsuitetransactions.model'
import { VEClient } from '@/utils/axios'

export const postDashboard = async (data: SearchDashboard): Promise<NetsuiteTransactionRes> => {
  const response = await VEClient.post(`/api/netsuite/dashboard`, data)
  return response.data
}